import { render, staticRenderFns } from "./Jewel04.vue?vue&type=template&id=23ed1e22&scoped=true&"
import script from "./Jewel04.vue?vue&type=script&lang=js&"
export * from "./Jewel04.vue?vue&type=script&lang=js&"
import style0 from "./Jewel04.vue?vue&type=style&index=0&id=23ed1e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed1e22",
  null
  
)

export default component.exports